import React, { Component } from "react";

import { addResellerRates } from "../../../libs/functions";

import Swal from "sweetalert2";
import Util from "../../../libs/util";

const PercentTextInput = (props) => {
	return (
		<div className="uk-inline uk-width-1-1">
			<span
				className={`uk-form-icon uk-form-icon-flip`}
				uk-icon="icon: fa-solid-percent; ratio: 0.6"
			/>
			<input className="uk-input" {...props} />
		</div>
	);
};

const FixedTextInput = (props) => {
	return (
		<div className="uk-inline uk-width-1-1">
			<span
				className={`uk-form-icon`}
				uk-icon="icon: fa-solid-dollar-sign; ratio: 0.6"
			/>
			<input className="uk-input" {...props} />
		</div>
	);
};

class AddRatesModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedCurrency: undefined,
			newRates: {},
		};

		this.addRatesModal = React.createRef();
		this.addRatesForm = React.createRef();
	}

	renderRateInputs = (gateway, type, region) => {
		return (
			<div className="uk-flex">
				<div className="uk-margin-small-right">
					<PercentTextInput
						name={`${gateway}-${type}-${region}-percent`}
						type="number"
						placeholder="Percent"
						onChange={(e) =>
							this.updateNewRates({
								type,
								region,
								isPercent: true,
								value: e.target.value,
							})
						}
					/>
				</div>
				<div className="uk-margin-small-left">
					<FixedTextInput
						name={`${gateway}-${type}-${region}-fixed`}
						type="number"
						placeholder="Fixed"
						onChange={(e) =>
							this.updateNewRates({
								type,
								region,
								isPercent: false,
								value: e.target.value,
							})
						}
					/>
				</div>
			</div>
		);
	};

	renderRateFields = (gateway, MDRTypes) => {
		return Object.keys(MDRTypes).map((type) => {
			return (
				<tr key={`new-${gateway}-${type}`}>
					<td className="uk-width-1-3">
						<img
							className="uk-img"
							src={`data:image/*;base64,${MDRTypes[type].image}`}
							width="35"
						/>
						<span className="uk-margin-small-left">{MDRTypes[type].label}</span>
					</td>
					<td className="uk-width-1-4">
						{this.renderRateInputs(gateway, type, "local")}
					</td>
					<td className="uk-width-1-4">
						{this.renderRateInputs(gateway, type, "overseas")}
					</td>
				</tr>
			);
		});
	};

	updateNewRates = (payload) => {
		const { newRates: curNewRates } = this.state;
		const { type, region, isPercent, value } = payload;

		if (value > 0) {
			if (!curNewRates[type]) curNewRates[type] = {};
			if (!curNewRates[type][region]) curNewRates[type][region] = {};
			curNewRates[type][region][isPercent ? "percent" : "fixed"] =
				Number(value);
		} else {
			delete curNewRates[type][region][isPercent ? "percent" : "fixed"];
			if (Object.keys(curNewRates[type][region]).length === 0)
				delete curNewRates[type][region];
			if (Object.keys(curNewRates[type]).length === 0) delete curNewRates[type];
		}

		this.setState({ newRates: curNewRates });
	};

	createNewRates = () => {
		const { selectedCurrency, newRates } = this.state;
		const {
			payload: { reseller, gateway },
		} = this.props;

		if (selectedCurrency && Object.keys(newRates).length > 0) {
			Swal.fire({
				title: "Adding new rates",
				onBeforeOpen: () => {
					Util.hideModal("add-reseller-rates");
					Swal.showLoading();
				},
				onOpen: async () => {
					try {
						const { status } = await addResellerRates({
							reseller,
							paymentGateway: gateway.name,
							currency: selectedCurrency,
							rates: newRates,
						});
						if (status === "success") {
							Swal.fire({
								icon: "success",
								title: "Rates Added",
							}).then(async () => {
								this.addRatesForm.current.reset();
								this.setState({ selectedCurrency: undefined });
								await this.props.refreshRates();
							});
						}
					} catch (err) {
						Swal.fire({
							icon: "error",
							title: `Unable to add new rates`,
							onClose: () => {},
						});
					}
				},
			});
		}
	};

	render() {
		const { payload } = this.props;
		const { gateway, availableCC, MDRTypes } = payload;

		return (
			<div
				id="add-reseller-rates"
				className="uk-modal-container"
				uk-modal="stack: true; esc-close: false; bg-close:false;"
				ref={this.addRatesModal}
			>
				<div className="uk-modal-dialog uk-modal-body">
					<h2 className="uk-modal-title">Add new rates for {gateway?.label}</h2>
					<form ref={this.scheduleRateUpdateForm}>
						{availableCC && (
							<div className="uk-margin">
								<label className="uk-form-label">Currency</label>
								<div>
									<select
										className="uk-select"
										onChange={(e) =>
											this.setState({ selectedCurrency: e.target.value })
										}
									>
										<option value=""></option>
										{availableCC.map((i) => (
											<option
												key={i.code}
												value={parseInt(i.number)}
												className="uk-text-capitalize"
											>
												{i.code}
											</option>
										))}
									</select>
									<table className="uk-table uk-table-striped uk-table-middle uk-margin-remove-bottom">
										<thead>
											<tr>
												<th className="uk-width-1-3">Payment Type</th>
												<th className="uk-width-1-4">Local Card</th>
												<th className="uk-width-1-4">Overseas Card</th>
											</tr>
										</thead>
									</table>
									<div className="add-reseller-rates-table uk-overflow-auto">
										<table className="uk-table uk-table-striped uk-table-middle uk-margin-remove-top">
											<tbody>
												{this.renderRateFields(gateway?.name, MDRTypes)}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						)}
					</form>
					<p className="uk-text-right">
						<button
							className="uk-button uk-button-default uk-modal-close"
							type="button"
						>
							Cancel
						</button>
						<button
							className="uk-button uk-button-primary"
							onClick={() => this.createNewRates()}
						>
							Add
						</button>
					</p>
				</div>
			</div>
		);
	}
}

export default AddRatesModal;
